<template>
<div class="form-elements">
  <div class="va-row">
    <div class="flex md12 xs12" style="padding-bottom:0;backgroundColor:#FFFFFF;">
      <vuestic-widget :headerText="'forms.inputs.appInfo' | translate" id="appInfoWrap" >
        <div class="va-row">
          <div class="flex xs12 md6" style="max-height:266px">
            <fieldset class="flex xs10 md10">
                <div class="form-group with-icon-right"
                :class="{'has-error': errors.has('appName'), 'valid': isFormFieldValid('appName')}">
                <div class="input-group">
                  <input
                    id="appNameInput"
                    name="appName"
                    data-vv-as="Name"
                    v-model="appForm.appName"
                    autocomplete="off"
                    maxlength="128"
                    v-validate="'required'"
                    required/>
                  <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label" for="appName">{{'createApp.appInfo.appName' | translate}}：</label><i class="bar"></i>
                  <small v-show="errors.has('appName')" class="help text-danger">
                    {{ errors.first('appName') }}
                  </small>
                </div>
              </div>

              <div class="form-group with-icon-right" :class="{'has-error': errors.has('contactEmail'), 'valid': simpleEmailValid}">
                <div class="input-group">
                  <input
                    id="contactEmail"
                    name="contactEmail"
                    autocomplete="off"
                    v-model="appForm.contactEmail"
                    v-validate="'required|email'"
                    required/>
                  <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label" for="contactEmail">
                    {{'createApp.appInfo.contactEmail' | translate}}：
                  </label>
                  <i class="bar"/>
                  <small v-show="errors.has('contactEmail')"
                    class="help text-danger">
                  {{ errors.first('contactEmail') }}
                  </small>
                </div>
              </div>

              <div class="form-group with-icon-right"
                :class="{'has-error': errors.has('website'), 'valid': isFormFieldValidisUrlValid('website')}">
                <div class="input-group">
                  <input
                    id="websiteUrl"
                    name="website"
                    data-vv-as="Name"
                    autocomplete="off"
                    @focus="changeLabelUp"
                    @blur="changeLabelBase"
                    v-model="appForm.website"
                    v-validate="'url'"
                    />
                  <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label" id="websiteLabel" for="website">{{'createApp.appInfo.website' | translate}}：</label><i class="bar"></i>
                  <small v-show="errors.has('website')" class="help text-danger">
                    {{ errors.first('website') }}
                  </small>
                </div>
              </div>

              <div class="form-group with-icon-right"
                id="selectWrapper"
                :class="{'has-error': initIndustryVaild, 'valid': industryVaild(appForm.industry)}">
                <div class="input-group">
                  <vuestic-simple-select
                    :label="$t('createApp.appInfo.industry')"
                    name="industry"
                    data-vv-as="Name"
                    v-model="appForm.industry"
                    ref="industryInput"
                    @input="forbiddenIndustryInput"
                    autocomplete="off"
                    v-validate="'required'"
                    required
                    option-key="value"
                    v-bind:options="industryOptions"/>
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa icon-right input-icon"></i>
                    <small v-show="initIndustryVaild" class="help text-danger" style="display:block;margin-top:-30px;">
                      {{ errors.first('industry') }}
                    </small>
                </div>
              </div>

            </fieldset>
          </div>

          <div class="flex xs12 md6" style="max-height:266px">
            <fieldset class="flex xs10 md10">
                <div class="form-group with-icon-right"
                  :class="{'has-error': errors.has('appNameShort'), 'valid': isFormFieldValid('appNameShort')}">
                  <div class="input-group">
                    <input
                      id="appNameShortInput"
                      name="appNameShort"
                      data-vv-as="Name"
                      v-model="appForm.appNameShort"
                      autocomplete="off"
                      maxlength="12"
                      v-validate="'required'"
                      required/>
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label" for="appNameShort">{{'createApp.appInfo.appNameShort' | translate}}：</label><i class="bar"></i>
                    <small v-show="errors.has('appNameShort')" class="help text-danger">
                      {{ errors.first('appNameShort') }}
                    </small>
                  </div>
                </div>

                <div class="form-group with-icon-right"
                :class="{'has-error': errors.has('managerName'), 'valid': isFormFieldValid('managerName')}">
                <div class="input-group">
                  <input
                    id="managerNameInput"
                    name="managerName"
                    data-vv-as="Name"
                    v-model="appForm.managerName"
                    autocomplete="off"
                    v-validate="'required'"
                    required/>
                  <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label" for="managerName">{{'createApp.appInfo.managerName' | translate}}：</label><i class="bar"></i>
                  <small v-show="errors.has('managerName')" class="help text-danger">
                    {{ errors.first('managerName') }}
                  </small>
                </div>
              </div>

              <div class="form-group with-icon-right"
                :class="{'has-error': errors.has('cellPhone'), 'valid': isFormFieldValid('cellPhone')}">
                <div class="input-group">
                  <input
                    id="cellPhone"
                    name="cellPhone"
                    data-vv-as="Name"
                    autocomplete="off"
                    maxlength="17"
                    @input="updatePhoneStatus(!isOverseaMobileVaild(appForm.cellPhone))"
                    @blur="updatePhoneStatus(!isOverseaMobileVaild(appForm.cellPhone))"
                    v-model="appForm.cellPhone"
                    v-validate="'required|verifyCellPhone'"
                    required/>
                  <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label" for="cellPhone">{{'createApp.appInfo.cellPhone' | translate}}：</label><i class="bar"></i>
                  <small v-show="errors.has('cellPhone')" class="help text-danger">
                    {{ errors.first('cellPhone') }}
                  </small>
                </div>
              </div>

              <div class="form-group with-icon-right"
                id="selectWrapper"
                :class="{'has-error': initSelectedVaild, 'valid': isCountryVaild(appForm.country)}">
                <div class="input-group">
                  <vuestic-simple-select
                    :label="$t('createApp.appInfo.country')"
                    name="country"
                    data-vv-as="Name"
                    v-model="appForm.country"
                    ref="myInput"
                    @input="forbiddenInput"
                    autocomplete="off"
                    v-validate="'required'"
                    required
                    option-key="description"
                    v-bind:options="countryOptions"/>
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa icon-right input-icon"></i>
                    <small v-show="initSelectedVaild" class="help text-danger" style="display:block;margin-top:-30px;">
                      {{ errors.first('country') }}
                    </small>
                </div>
              </div>

            </fieldset>
          </div>
        </div>

      </vuestic-widget>
    </div>

    <div class="flex md12 xs12" style="padding-top:0">
      <vuestic-widget :headerText="'forms.inputs.report2Send' | translate" class="report-send-to">
        <div class="va-row">
          <div class="flex xs12 md12">
            <div class="form-group with-icon-right"
                :class="{'has-error': initmailsVaild, 'valid': isSuccessfulEmailValid}">
              <div class="input-group">
                <textarea
                  id="userEmails"
                  name="userEmails"
                  class="emailsTextArea"
                  v-model="appForm.userEmails"
                  v-validate="'required'"
                  autocomplete="off"
                  maxlength="255"
                  rows="3"
                  style="overflow:hidden;"
                  :style="marginTop"
                  @input="resizeEmailLabel($event, !isSuccessfulEmailValid)"
                  @blur="focusEmailLabel($event, !isSuccessfulEmailValid)"
                  placeholder="email;email"
                  required>
                </textarea>
                <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                <i class="fa fa-check valid-icon icon-right input-icon"></i>
                <label class="control-label" for="userEmails">{{'forms.inputs.emailValidatedSuccess' | translate}} </label><i class="bar"></i>
                <small v-show="initmailsVaild" class="help text-danger">
                  {{ mailsInfoMsg || errors.first('userEmails') }}
                </small>
                <label>{{ $t('t.youCanAddUp') }}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="va-row">
          <div class="flex xs12 md12">
            <div class="section-confirm">
              <button class="btn btn-primary btn-sm confirm-ok" id="confirmCreateApp" @click="submitData">
                {{'basic.button.confirm' | translate}}
              </button>
              <button class="btn btn-secondary btn-sm confirm-cel" id="cancelCreateApp" @click="backBtnPre">
                {{'basic.button.cancel' | translate}}
              </button>
            </div>
          </div>
        </div>
      </vuestic-widget>
    </div>
  </div>

  <div class="flex xs12 md6 flex-center" v-if="isToastContent">
    <div class="toasted-container sample-toasted-container shrink">
      <div class="toasted vuestic-toast none default">
        <i class="fa" :class="toastIcon" v-if="toastIcon"/>
        {{toastText}}
      </div>
    </div>
  </div>

</div>
</template>

<script>
import { request, checkEmail, checkUrl, checkMobileOversea, exeTextLine } from '@/utils/utils.js'
export default {
  name: 'new-app',
  data () {
    this.$validator.extend('verifyCellPhone', {
      validate: (value, ref) => {
        const status = checkMobileOversea(value)
        return status
      },
      getMessage: (field) => 'The ' + field + ' is not valid.'
    })
    return {
      submitBtnFlag: true,
      newApplist: [],
      appForm: {
        appName: '',
        appNameShort: '',
        contactEmail: '',
        website: '',
        managerName: '',
        cellPhone: '',
        country: {},
        userEmails: '',
        industry: '',
      },
      paddTop: {
        'padding-top': '18px'
      },
      marginTop: {
        'margin-top': '22px'
      },
      countryOptions: [],
      industryOptions: [
        // Social
        { id: '1', value: 'Digital Content' },
        { id: '2', value: 'E - Commerce' },
        { id: '3', value: 'FX' },
        { id: '4', value: 'Game' },
        { id: '5', value: 'IT Technical Service' },
        { id: '6', value: 'Logistics' },
        { id: '7', value: 'Marketing' },
        { id: '8', value: 'Service' },
        { id: '9', value: 'Securities Dealer' },
        { id: '10', value: 'PSP (Internal)' },
        { id: '11', value: 'PSP' },
        { id: '12', value: 'Others' },
      ],
      cellPhoneStatus: false,
      mailsStatus: false,
      countryStatus: false,
      industryStatus: false,
      isToastContent: false,
      toastIcon: 'fa-star-o',
      toastText: 'App has been created and completed!',
      toastPosition: 'top-center',
      isToastFullWidth: false,
      toastDuration: 2500,
      mailsInfoMsg: 'The userEmails field must be a valid email.'
    }
  },
  computed: {
    isSuccessfulEmailValid () {
      // 255个字符，并且最多5个邮箱
      let isValid = false
      if (this.formFields.userEmails) {
        if (this.appForm.userEmails.includes(';')) {
          let subEmails = this.appForm.userEmails.split(';')
          let results = []
          for (let j = 0; j < subEmails.length; j++) {
            if (subEmails[j] && subEmails[j] !== '') {
              checkEmail(subEmails[j]) ? results.push(1) : results.push(0)
            }
          }
          let fg = !(results.includes(0) || results.length > 5)
          if (results.length > 5) {
            this.mailsInfoMsg = 'You can only enter 5 email address at most.'
          } else if (results.includes(0)) {
            this.mailsInfoMsg = 'The userEmails field must be a valid email.'
          }
          isValid = fg
        } else {
          isValid = this.formFields.userEmails.validated && this.formFields.userEmails.valid
        }
      }
      return isValid
    },
    simpleEmailValid () {
      let isValid = false
      if (this.formFields.contactEmail) {
        isValid = this.formFields.contactEmail.validated && this.formFields.contactEmail.valid
      }
      return isValid
    },
    initPhoneVaild () {
      return this.cellPhoneStatus
    },
    initSelectedVaild () {
      return this.countryStatus
    },
    initIndustryVaild () {
      return this.industryStatus
    },
    initmailsVaild () {
      return this.mailsStatus
    },
  },
  mounted () {
    this.init()
    exeTextLine('', 'emailsTextArea')
    this.initDropdown()
  },
  methods: {
    init () {
      this.$refs.industryInput.$el.getElementsByTagName('input')[0].readOnly = true
      this.$refs.industryInput.$el.getElementsByTagName('input')[0].autocomplete = 'off'
      // this.$refs.myInput.$el.getElementsByTagName('input')[0].readOnly = true
      this.$refs.myInput.$el.getElementsByTagName('input')[0].autocomplete = 'off'
    },
    updatePhoneStatus (bol) {
      this.cellPhoneStatus = bol
    },
    updateMailsStatus (bol) {
      this.mailsStatus = bol
    },
    forbiddenInput (val) {
      if (!val) {
        this.$refs.myInput.$el.getElementsByTagName('input')[0].style.height = '28px'
        this.countryStatus = true
      } else {
        this.countryStatus = false
      }
    },
    forbiddenIndustryInput (val) {
      if (!val) {
        this.$refs.industryInput.$el.getElementsByTagName('input')[0].style.height = '28px'
        this.industryStatus = true
      } else {
        this.industryStatus = false
      }
    },
    resizeEmailLabel (e, bol) {
      e.currentTarget.style.marginTop = '10px'
      this.updateMailsStatus(bol)
    },
    focusEmailLabel (e, bol) {
      e.currentTarget.style.marginTop = '22px'
      this.updateMailsStatus(bol)
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid = this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    isFormFieldValidisUrlValid (field) {
      let isValid = false
      if (checkUrl(field)) {
        isValid = true
      }
      return isValid
    },
    isOverseaMobileVaild (field) {
      let isValid = false
      if (checkMobileOversea(field)) {
        isValid = true
      }
      return isValid
    },
    isCountryVaild (field) {
      let isValid = false
      if (this.countryStatus) {
        isValid = true
      }
      return isValid
    },
    industryVaild (field) {
      let isValid = false
      if (this.industryStatus) {
        isValid = true
      }
      return isValid
    },
    backBtnPre () {
      this.$router.push({
        name: 'AppManagement',
      })
    },
    initDropdown () {
      let token = localStorage.getItem('Authorization')
      this.loadingFullScreen("initDropdownLoading", "Loading", "fa fa-hourglass-half")
      let url = '/api/dashboard/basic/getDropdown?access_token=' + token
      request({
        method: 'post',
        url
      }).then(res => {
        this.initDropdownLoading.close();
        var allRegions = res.data.regions
        for (let i = 0; i < allRegions.length; i++) {
          let oneRegion = {
            id: i + 1,
            code: allRegions[i].code,
            description: allRegions[i].name
          }
          this.countryOptions.push(oneRegion)
        }
      }).catch(() => {
        this.initDropdownLoading.close();
      })
    },
    loadingFullScreen(controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    submitData () {
      const self = this
      if (self.appForm.userEmails.trim() === '') {
        self.mailsStatus = true
      }
      self.$validator.validateAll({
        appName: self.appForm.appName,
        contactEmail: self.appForm.contactEmail,
        appNameShort: self.appForm.appNameShort,
        managerName: self.appForm.managerName,
        cellPhone: self.appForm.cellPhone,
        userEmails: self.appForm.userEmails
      }).then(result => {
        if (!result) { window.scrollTo(0,0);return }
        self.appdata()
      })
    },
    // 提交用户新建APP的数据信息
    appdata () {
      if (this.submitBtnFlag == false) {
        return false
      }
      let formApp = {
        'app_name': this.appForm.appName.trim().replace('\\u200B', ''),
        'app_name_short': this.appForm.appNameShort.trim().replace('\\u200B', ''),
        'contact': this.appForm.managerName.trim().replace('\\u200B', ''),
        'contact_email': this.appForm.contactEmail,
        'phone': this.appForm.cellPhone,
        'region': this.appForm.country.code,
        'report_email': this.appForm.userEmails,
        'index_url': this.appForm.website,
        'industry': this.appForm.industry.id,
      }
      if (!formApp.app_name || !formApp.app_name_short || !formApp.region || !formApp.contact || !formApp.contact_email || !formApp.phone || !formApp.report_email || !formApp.industry) {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: '<strong style="font-size:1rem;">' + this.$t('order.requireText') + '</strong>',
          center: true,
          type: 'warning'
        })
        return
      }
      let token = localStorage.getItem('Authorization')
      this.loadingFullScreen("addAppLoading", "Loading", "fa fa-hourglass-half")
      request({
        method: 'put',
        url: `api/dashboard/app/add?access_token=${token}`,
        data: formApp,
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        this.addAppLoading.close();
        this.newApplist = res.data
        // console.log(this.newApplist.code + ' ---> ' + this.newApplist.msg)
        if (res.data.code == 10000) {
          if (res.data.data) {
            this.toastText = res.data.data.app_name + ' Created!'
          } else {
            this.toastText = res.data.msg || 'Success!'
          }
          this.launchToast()
        } else {
          this.toastText = res.data.msg
          this.launchToast()
        }
        this.backBtnPre()
        this.submitBtnFlag = true
      }).catch(err => {
        this.addAppLoading.close();
        this.toastText = err.msg
        this.launchToast()
        this.submitBtnFlag = true
      })
      this.submitBtnFlag = false
    },
    launchToast () {
      this.isToastContent = true
      this.showToast(
        this.toastText,
        {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
        }
      )
      this.isToastContent = false
    },
    changeLabelUp () {
      // document.getElementById("newEmail").className = "control-label2"
    },
    changeLabelBase () {
      if (!document.getElementById('websiteUrl').value) {
        document.getElementById('websiteLabel').className = 'control-label'
      } else {
        document.getElementById('websiteLabel').className = 'control-label2'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.emailsTextArea {
  width: 100%;
  height: auto;
  border: none;
  outline: none;
  font-size: 1rem;
  color: #fff;
  box-sizing: border-box;
  padding: 0.4rem 0;
  border-bottom: 1px solid #fff;
}
.section-confirm {
  margin: 0 auto;
  width: 400px;
  display: flex;
  justify-content: space-around;
}
/deep/ #selectWrapper {
  .form-group {
    min-height: 30px;
  }
  .control-label {
    top: -10px;
  }
  input[name = "simple-select"] {
    height: 33px;
  }
  input.has-value {
    height: 28px !important;
  }
}
/deep/ .vuestic-widget {
  -webkit-box-shadow: 0 0 0 0;
  box-shadow: 0 0 0 0;
}
.form-group #websiteUrl:valid ~ .control-label {
  color: #b3b3b3;
}
::-webkit-input-placeholder { /* WebKit browsers */
  color: #999;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color: #999;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #999;
}
:-ms-input-placeholder { /* Internet Explorer 10+ */
  color: #999;
}
/deep/ #appInfoWrap.vuestic-widget {
  .vuestic-widget-body {
    padding-bottom: 0
  }
}
/deep/ .valid.form-group .control-label.control-label {
  color: #b3b3b3;
  position: absolute;
  top: -16px;
  text-transform: none;
  font-size: 16px;
  font-weight: normal;
  pointer-events: none;
}
.control-label2 {
  color: #4ae387;
  position: absolute;
  top: -10px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  pointer-events: none;
}
@media only screen and (max-width: 750px) {
  #confirmCreateApp, #cancelCreateApp {
    padding: 0.5rem 1rem;
  }
}
/deep/ .vuestic-simple-select__dropdown-menu .scrollbar-wrapper {
    max-height: 200px !important;
    // overflow-y: scroll;
}
.report-send-to {
  padding-top: 20px;
}
</style>
